import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { XpoBadgeModule } from '@xpo-ltl/ngx-ltl-core/badge';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoErrorPagesModule } from '@xpo-ltl/ngx-ltl-core/error-pages';
import { XpoFooterModule } from '@xpo-ltl/ngx-ltl-core/footer';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoStatusIndicatorModule } from '@xpo-ltl/ngx-ltl-core/status-indicator';
import { AlertDialogComponent } from './components/alert/alert-dialog.component';
import { AuthRedirectComponent } from './components/auth-redirect/auth-redirect.component';
import { NumericEditorComponent } from './components/cell-editors/numeric-editor/numeric-editor.component';
import { SelectCellEditorComponent } from './components/cell-editors/select-cell-editor/select-cell-editor.component';
import { BooleanCellRendererComponent } from './components/cell-renderers/boolean-cell-renderer/boolean-cell-renderer.component';
import { IconButtonCellRendererComponent } from './components/cell-renderers/icon-button-cell-renderer/icon-button-cell-renderer.component';
import { LinkCellRendererComponent } from './components/cell-renderers/link-cell-renderer/link-cell-renderer.component';
import { StatusIndicatorCellRendererComponent } from './components/cell-renderers/status-indicator-cell-renderer/status-indicator-cell-renderer.component';
import { FooterComponent } from './components/footer/footer.component';
import { GridAppliedFiltersComponent } from './components/grid-applied-filters/grid-applied-filters.component';
import { AppliedFiltersDisplayPipe } from './components/grid-applied-filters/helper/applied-filer.pipe';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { SnackBarMessageComponent } from './components/snack-bar-message/snack-bar-message.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { UserRamRoleSelectionComponent } from './components/user-ram-role-selection/user-ram-role-selection.component';
import { ErrorPipe } from './pipes/error.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';

@NgModule({
  declarations: [
    // Components
    GridAppliedFiltersComponent,
    AlertDialogComponent,
    SnackBarMessageComponent,
    FooterComponent,
    LinkCellRendererComponent,
    IconButtonCellRendererComponent,
    BooleanCellRendererComponent,
    StatusIndicatorCellRendererComponent,
    NumericEditorComponent,
    ErrorPipe,
    YesNoPipe,
    AppliedFiltersDisplayPipe,
    SelectCellEditorComponent,
    TooltipComponent,
    UserRamRoleSelectionComponent,
    AuthRedirectComponent,
    NotAuthorizedComponent,
    // Pipes/Directives
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    XpoDialogModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    XpoButtonModule,
    MatChipsModule,
    XpoChipsModule,
    MatProgressSpinnerModule,
    XpoIconModule,
    XpoFooterModule,
    XpoBadgeModule,
    MatTooltipModule,
    MatAutocompleteModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    XpoErrorPagesModule,
    XpoStatusIndicatorModule,
  ],
  exports: [
    // Components
    GridAppliedFiltersComponent,
    AlertDialogComponent,
    SnackBarMessageComponent,
    FooterComponent,
    LinkCellRendererComponent,
    IconButtonCellRendererComponent,
    BooleanCellRendererComponent,
    StatusIndicatorCellRendererComponent,
    SelectCellEditorComponent,
    NumericEditorComponent,
    TooltipComponent,
    UserRamRoleSelectionComponent,
    NotAuthorizedComponent,
    // Pipes/Directives
    ErrorPipe,
    YesNoPipe,
    AppliedFiltersDisplayPipe,
  ],
  // providers:  MAKE providedIn: 'root' on your services!!!
})
export class SharedModule {}
